<img class="vertafore-logo" src="/images/sircon-logo-black.svg" alt="Sircon, a Vertafore company" />

<div *ngIf="!isSsoEnabled" class="signup-account">
    <span class="sign-in-prompt">Already have an account?</span>
    <button type="button" class="sign-in-btn btn btn-wide btn-secondary" (click)="goToSignIn()">Sign In</button>
</div>
